export const SeccionesActionTypes = {
  API_RESPONSE_SUCCESS: '@@secciones/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@secciones/API_RESPONSE_ERROR',

  GET_SECCION: '@@secciones/GET_SECCION',
  LIST_SECCIONES: '@@secciones/LIST_SECCIONES',
  ADD_SECCION: '@@secciones/ADD_SECCION',
  UPDATE_SECCION: '@@secciones/UPDATE_SECCION',
  DELETE_SECCION: '@@secciones/DELETE_SECCION',

  RESET: '@@secciones/RESET'
}
